"use strict";

module.exports = {
  trackingPath:
    "https://staging-api.agentshield.com/t/1x1clear.gif" +
    "?t=" +
    new Date().getTime(),
  server: "https://staging-app.agentshield.com",
  restPath: "https://staging-api.agentshield.com/agent-shield-1.0/rest",
  apiPath: "https://staging-api.agentshield.com/agent-shield-1.0",
  widgetHost: "https://staging-widgets.agentshield.com",
  intercomAppId: "ijh052u7",
  intercomAppIdAgent: "fglggop8"
};
